import "../styles/Contact.css"
import React from 'react';
import styles from "../styles/layout/layout.module.css";
import {Link} from "react-router-dom";
import DishWidget from "../components/DishWidget";
 export const ContactPage = () => {

    return <div className={"container-home"}>

        <div className={"container"}>
            <div className="section menu bg-black-10 text-center ">
                <div className={"wrap-section"}>
                    <section className={"section-find-table section"}>
                        <div className="container">

                            <div className="quote">”</div>

                            <p className="headline-2 testi-text">
                                Wir möchten Ihnen herzlich für Ihren Besuch im Restaurant Ha Mi danken und freuen uns auch sehr
                                über
                                Ihren Willkommensgruß und Ihre Komplimente. Wir hoffen, Sie in Zukunft begrüßen zu dürfen, damit
                                Sie
                                noch mehr besondere Aromen aus der einzigartigen Kombination der vietnamesischen Küche genießen
                                können.
                            </p>

                            <div className="wrapper">
                                <div className={styles.separator}></div>
                                <div className={styles.separator}></div>
                                <div className={styles.separator}></div>
                            </div>


                        </div>
                    </section>
                    <section className={"section feature about text-center"}>

                        <div className="form reservation-form bg-black-10" id={"contact-id"}>

                            <DishWidget/>

                            <div className="form-right text-center form-find-table">

                                <h2 className="headline-2 text-center">Kontaktieren Sie uns</h2>


                                <div className={styles.separator}></div>
                                <div>
                                    <p className="contact-label">Standort</p>
                                    <Link to="https://maps.app.goo.gl/dczj2LdVkYREyRVk8">
                                        <address className="body-4">
                                            Mönchstraße 01, 09599 Freiberg
                                        </address>
                                    </Link>
                                </div>
                                <div>
                                    <p className="contact-label">Öffnungszeiten</p>
                                    <p className="body-4">
                                        Montag: Geschlossen<br/>
                                        Dienstag-Sonntag: <br/>
                                        11:00-15:00 und 17:00-22:00
                                    </p>
                                </div>
                                <div>
                                    <p className="contact-label">Mittagszeit</p>

                                    <p className="body-4">
                                        Dienstag-Sonntag: <br/>
                                        11:00-15:00
                                    </p>
                                </div>
                                <div>
                                    <p className="contact-label">Kücheschluss</p>
                                    <p className="body-4">
                                        21:30
                                    </p>
                                </div>
                            </div>

                        </div>

                        <div className="container">


                            <img src="/assets/images/shape-7.png" width="197" height="194" loading="lazy" alt=""
                                 className="shape shape-5"/>
                        </div>
                    </section>

                </div>


            </div>
        </div>

    </div>
}